<template>
  <div class="fade-in">
    <div class="columns is-multiline">
      <div class="column is-full">
        <div>
          <h1 class="title">Account Settings</h1>
          <br />
          <strong>Settings for the practice</strong>
        </div>

        <div class="mt3">
          <div class="mt1">
            <router-link
              :to="{ name: 'locations-list' }"
              v-if="$can('interview:update|interview:manage')"
            >
              <i class="fa fa-map-o mr1"></i> Locations
            </router-link>
          </div>

          <div class="mt1">
            <router-link
              :to="{ name: 'virtual-visit-email' }"
              v-if="$can('interview:update|interview:manage')"
            >
              <i class="fa fa-envelope-o mr1"></i> Virtual Visit Emails
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "settings-index"
};
</script>

<style lang="scss" scoped></style>
